// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteService extends ApiService {

  new(product: string): Promise<any> {
    return this.get(`/v2/quote/start/${product}`).toPromise();
  }

  getBySlug(uuid: string): Promise<any> {
    return this.get(`/v2/quote/${uuid}`).toPromise();
  }

  estimate(uuid: string, params?: string): Promise<any> {
    let url = `/v2/quote/${uuid}/estimate`;
    if (params) {
      url = `${url}?${params}`;
    }
    return this.get(url).toPromise();
  }

  prepareQuote(payload: any): Promise<any> {
    return this.post('/v2/quote/prepare', payload, { withCredentials: true }).toPromise();
  }


  /* Central APIs below this point */

  search(productClass: string, queryParamsString: string): Promise<any> {
    return this.get(`/v2/quote/supersearch/${productClass}${queryParamsString}`).toPromise();
  }

  searchByCustomer(productClass: string, customerSlug: string): Promise<any> {
    return this.get(`/admin/quote/${productClass}/by-user/${customerSlug}`).toPromise();
  }
}
